import { useContext } from 'react';
import { FilterContext } from './FiltersProvider.js';

function useFiltersContext() {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error("useFilterContext should be wrapped in Filters.Provider");
    }
    return context;
}

export { useFiltersContext };
//# sourceMappingURL=useFiltersContext.js.map
